/* eslint-disable yoda */
import { formatMediaForUploader, getOptimizedThumbnailUrl } from './format.utils';

/**
 * Consolidates image and video embed data into a single, sorted array for the frontend.
 * @param {object} rawData The raw listing/space object returned from the API.
 * @returns {Array<object>} A sorted array of all media items.
 */

export const buildAllMedia = (rawData) => {
  const listing = rawData || {};
  const images = listing.images || [];
  const embedMedia = listing.embed_media || [];

  const mediaItems = images.map(image => formatMediaForUploader(image));

  const embedMediaItems = embedMedia
    .filter(
      item => item.embed_type === 'video' || item.embed_type === '3d'
    )
    .map(item => {
      let thumbnailUrl = getOptimizedThumbnailUrl(item);

      return formatMediaForUploader({
        ...item,
        thumbnail_url: thumbnailUrl
      });
    });

  const finalMedia = mediaItems.concat(embedMediaItems);

  return finalMedia.sort((a, b) => a.sortOrder - b.sortOrder);
};
